import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { OrderProvider } from "./MenuAndOrders/OrderMenu/MenuOrder/OrderContext";

const FoodMenuList = Loadable(
  lazy(() =>
    import("./FoodMasterMenu/FoodMenu").then(({ FoodMenuList }) => ({
      default: FoodMenuList,
    }))
  )
);

const FoodItemsList = Loadable(
  lazy(() =>
    import("./FoodItems/FoodItemsList").then(({ FoodItemsList }) => ({
      default: FoodItemsList,
    }))
  )
);

const FoodCategoryList = Loadable(
  lazy(() =>
    import("./FoodCategory/FoodCategoryList").then(({ FoodCategoryList }) => ({
      default: FoodCategoryList,
    }))
  )
);

const ManageFoodMasterMenu = Loadable(
  lazy(() =>
    import("./FoodMasterMenu/ManageFoodMasterMenu").then(
      ({ ManageFoodMasterMenu }) => ({
        default: ManageFoodMasterMenu,
      })
    )
  )
);

export const foodMenuRoutes = [
  {
    path: "/master-food-menu",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_MENU]}>
        <FoodMenuList type="master" />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/master-food-menu/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_MENU]}>
        <ManageFoodMasterMenu type="master" />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/master-food-menu/manage/:master_menu_uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_MENU]}>
        <ManageFoodMasterMenu type="master" />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/food-items",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.FOOD_ITEMS]}>
        <OrderProvider>
          <FoodItemsList />
        </OrderProvider>
      </AuthorizedRoute>
    ),
  },

  {
    path: "/food-categories",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.FOOD_CATEGORIES]}>
        <FoodCategoryList />
      </AuthorizedRoute>
    ),
  },
];
